import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ReportExecution, ReportExecutionCreate, ReportExecutionFilter } from '../data/reportExecution';

export function createReportExecutionService(client: AxiosInstance) {
  return createCrudService<ReportExecution, ReportExecutionCreate, ReportExecutionFilter>(
    client,
    '/reporting/ReportExecution',
    'id',
  );
}

export type ReportExecutionService = CrudService<ReportExecution, ReportExecutionCreate, ReportExecutionFilter>;
